<div class="row" *ngFor="let res of reservations">
  <div class="col-md-12 col p-0" *ngIf="!res.archived" [attr.id]="'reservation-'+res.id">
    <div class="row">
      <div class="col-md-7 col-sm-12 col-xs-12" *ngIf="!res.isEdit">
        <app-reservation-card [reservation]="res" [enabledEdit]="reservationDate.isToday"></app-reservation-card>
      </div>
      <div class="col-md-7 col-sm-12 col-xs-12" *ngIf="res.isEdit">
        <app-reservation-card-edit [reservation]="res"></app-reservation-card-edit>
      </div>
      <div class="col-md-5 col-sm-12 col-xs-12 d-none d-md-block">
        <app-reservation-note [reservation]="res"></app-reservation-note>
      </div>
    </div>
  </div>
  <div class="col-md-12 col" *ngIf="res.archived">
    <app-reservation-card-small [reservation]="res"></app-reservation-card-small>
  </div>
</div>
